<template>
    <Modal title="Create Parent Company" ref="modalRef">
        <template v-slot:body>
            <div class="margin-b-1">
                Create parent company for the following {{ props.companies.length }} divisions:
                <CompanyList :companies="props.companies" ref="companyListRef"/>
            </div>
            <div class="margin-b-2">Parent company name:</div>
            <div class="margin-b-1">
                <input class="parent-name-text" type="text" v-model="name" />
            </div>
            <div class="margin-b-2">Parent company notes:</div>
            <textarea v-model="notes" class="parent-notes-text"></textarea>
        </template>
        <template v-slot:footer>
            <input class="cancel-button button button-secondary" type="button" value="Cancel" @click="cancel()" />
            <input type="button" value="Save" class="button" @click="save()" />
        </template>
    </Modal>
</template>

<script setup>
    import { ref, inject, defineProps, onMounted, defineEmits, onBeforeMount } from 'vue';
    import { Modal as ModalLib, promptModal } from 'jenesius-vue-modal';
    import Modal from './Modal.vue';
    import Alert from '../components/Alert.vue';
    import Error from '@/components/Error.vue';
    import CompanyList from '@/components/CompanyList.vue';


    const props = defineProps({
        companies: {
            type: Array,
            required: true
        },

        moveNotesToParent: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits([ModalLib.EVENT_PROMPT]);
    const api = inject('api');

    const name = ref('');
    const notes = ref('');
    const modalRef = ref();
    const companyListRef = ref();

    onBeforeMount(() => {
        if (props.moveNotesToParent) {
            // all notes should be the same, so grab notes from first company
            notes.value = props.companies[0].description;
        }
    });

    onMounted(() => {
        console.log('companies:', props.companies);
    });

    async function save() {
        const removedCompanies = companyListRef.value.removedCompanies;

        const remainingCompanies = props.companies
            .filter(c => removedCompanies.indexOf(c.id) === -1)
            .map(c => c.id);

        if (remainingCompanies.length > 0) {
            if (name.value.length > 0) {
                modalRef.value.showActivityIndicator = true;

                try {
                    await api.createGroup(
                        name.value,
                        notes.value,
                        remainingCompanies
                    );

                    if (props.moveNotesToParent) {
                        remainingCompanies.forEach(async id => api.updateCompanyNotes(id, ''));
                    }

                    modalRef.value.showActivityIndicator = false;
                    emit(ModalLib.EVENT_PROMPT, true);
                }
                catch (err) {
                    promptModal(Error, { message: 'Error creating parent', details: err.stack });
                }
            }
            else {
                promptModal(Alert, { title: 'Error', text: 'Please give the parent company a name.' });
            }
        }
        else {
            promptModal(Alert, { title: 'Error', text: 'No companies have been selected for this group. Please try again.' });
        }
    }

    function cancel() {
        emit(ModalLib.EVENT_PROMPT, false);
    }
</script>

<style scoped>
    .parent-name-text {
        width: 100%;
    }

    .parent-notes-text {
        width: 100%;
        height: 200px;
        resize: none;
    }

    .cancel-button {
        margin-right: 10px;
    }
</style>
